import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=0604c250&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&id=0604c250&prod&lang=scss&scoped=true&"
import style1 from "./Products.vue?vue&type=style&index=1&id=0604c250&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604c250",
  null
  
)

export default component.exports